<template>
  <div>
    <indexCompanyList :title="'资源方'" :type="1"></indexCompanyList>
    <indexCompanyList :title="'采购方'" :type="2"></indexCompanyList>
  </div>
</template>

<script>
    // import api from '../api/api'
    // import layer from "layui-layer";
    import indexCompanyList from './indexCompanyList'

    export default {
      name: 'index',
      components:{
        indexCompanyList
      },
      data: function(){
        return {
          // title: null,
          // searchType: null,
          // type: null
        }
      },
      created: function(){
        console.log("index created");
      },
      methods: {

      }
    }
</script>
